import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=395bd7c2&"
import script from "./SimpleCard.vue?vue&type=script&lang=ts&"
export * from "./SimpleCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports